import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { ADD_RIGHTS_QUERY_KEY } from "../constants";
import { AddRightsService } from "../services/addRights.service";

export function useStartAddRight(handleSuccess?: () => void) {
  const {
    mutate: startAdRight,
    isLoading: isStarting,
    isSuccess: isStarted,
    variables,
  } = useMutation({
    mutationFn: ({
      adRightsTrackerId,
      startDate,
    }: {
      adRightsTrackerId: string;
      startDate: string;
    }) =>
      AddRightsService.startAdRight(adRightsTrackerId, startDate).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: { skipInvalidation: true },
    onSuccess: (c) => {
      handleSuccess?.();
      c.invalidateQueries({
        queryKey: [ADD_RIGHTS_QUERY_KEY],
        exact: false,
      });
    },
  });

  return {
    startAdRight,
    isStarting,
    isStarted,
    variables,
  };
}
